export enum CardPriceCurrenciesEnum {
  EUR = "EUR",
  USD = "USD",
}

export enum CardPriceMarketEnum {
  Cardmarket = "cardmarket",
  TCGPlayer = "tcgplayer",
}

export interface PriceHistory {
  timestamp: Date;
  value: number;
}

export enum PricePeriodEnum {
  "3Day" = "3d",
  "7Day" = "7d",
  "14Day" = "14d",
  "30Day" = "30d",
  "60Day" = "60d",
}

// Single (period, percent/abs) entry on a delta map.
export type DeltaEntry = {
  [period: string]: {
    abs: number;
    percent: number;
  };
};

export interface EmbeddedCardPrice {
  value: {
    /**
     * Primary/any-price field. Mirrored from foil (or etched) by the
     * backend's `fillValues` when no real nonfoil chart exists, so it's
     * always populated when *any* chart data is present. Read this when
     * you just want "a representative price" for the card. For
     * finish-specific display use the registry-backed per-finish fields instead.
     */
    default: number;
    foil: number;
    etched?: number;
    metal?: number;
    metalDeluxe?: number;
    /** Honest per-finish nonfoil — non-zero only when a real nonfoil
     *  chart source exists. Absent === 0. */
    nonfoil?: number;
    trendDefault: number;
    trendFoil: number;
    trendEtched?: number;
    trendMetal?: number;
    trendMetalDeluxe?: number;
    trendNonfoil?: number;
    lowDefault?: number;
    lowFoil?: number;
    lowEtched?: number;
    lowMetal?: number;
    lowMetalDeluxe?: number;
    lowNonfoil?: number;
  };

  // Source-reported timestamp of whichever finish fed `value.default`
  // (not the updater run time). Per-finish timestamps below override
  // it for finish-aware UIs that want to report freshness for their
  // specific finish row.
  timestamp: string;
  currency: CardPriceCurrenciesEnum;
  nonfoilTimestamp?: string;
  foilTimestamp?: string;
  etchedTimestamp?: string;
  metalTimestamp?: string;
  metalDeluxeTimestamp?: string;
  // Which finish's chart actually fed `value.default` on this specific
  // doc. For collection-cards / trade-items this is set per-doc by the
  // finish-specific update pipeline. When `source` differs from the
  // doc's own finish, `value.default` is a mirror and the UI should
  // render the ≈ approximate marker. Typed as a free string so the
  // type doesn't break when the backend registry grows (FinishEnum is
  // the canonical runtime check).
  source?: string;
  deltas: {
    default?: DeltaEntry;
    foil?: DeltaEntry;
    nonfoil?: DeltaEntry;
    metal?: DeltaEntry;
    metalDeluxe?: DeltaEntry;
    trendDefault?: DeltaEntry;
    trendFoil?: DeltaEntry;
    trendEtched?: DeltaEntry;
    trendMetal?: DeltaEntry;
    trendMetalDeluxe?: DeltaEntry;
    trendNonfoil?: DeltaEntry;
    lowDefault?: DeltaEntry;
    lowFoil?: DeltaEntry;
    lowEtched?: DeltaEntry;
    lowMetal?: DeltaEntry;
    lowMetalDeluxe?: DeltaEntry;
    lowNonfoil?: DeltaEntry;
  };
}
